import { render } from "./RecordPayment_component.vue?vue&type=template&id=7e6caf85&scoped=true"
import script from "./RecordPayment_component.vue?vue&type=script&lang=js"
export * from "./RecordPayment_component.vue?vue&type=script&lang=js"

import "./RecordPayment_component.vue?vue&type=style&index=0&id=7e6caf85&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e6caf85"]])

export default __exports__